import React, { Component } from 'react'
import Loader from './Loader'
import './Visualize.css'

class Visualize extends Component {
  render () {
    return (
      <div id='visualize'>
        {
          this.props.assetCollection
          ? <Loader manifest={this.props.assetCollection} />
          : null
        }
        {this.props.children}
      </div>
    )
  }
}

export default Visualize



// WEBPACK FOOTER //
// ./src/lib/react-visualize/Core/Visualize.js